<template>
  <p class="last-update">
    <i class="fas fa-calendar-alt mr-2"></i>
    Ultimo aggiornamento: 30 giugno 2025
  </p>
</template>

<script>
export default {
  name: 'DataDeletionLastUpdate'
}
</script>

<style scoped>
.last-update {
  margin-top: 2rem;
  font-size: 0.95rem;
  color: rgba(255, 255, 255, 0.7);
  animation: fadeInUp 0.8s ease-out 1s both;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
